// extracted by mini-css-extract-plugin
export var bordersection = "OurCentresMap-module--bordersection--fe6ae";
export var bordertop = "OurCentresMap-module--bordertop--764da";
export var cardoverlaywrapper = "OurCentresMap-module--cardoverlaywrapper--1908f";
export var mapcontainer = "OurCentresMap-module--mapcontainer--d1c1a";
export var mapwrapper = "OurCentresMap-module--mapwrapper--330dd";